import { useState, useEffect } from 'react';
import { DownloadSimple, X } from '@phosphor-icons/react';

export default function InstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setInstallEvent(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setInstallEvent(null);
    });

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!installEvent) return;
    installEvent.prompt();
    const result = await installEvent.userChoice;
    if (result.outcome === 'accepted') {
      setInstallEvent(null);
    }
  };

  if (isInstalled || dismissed || !installEvent) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-96 z-50 animate-fade-in-up" data-testid="install-prompt">
      <div className="bg-[#141414] border border-[#FF3B30]/30 p-4 flex items-center gap-3 shadow-lg shadow-black/40">
        <div className="w-12 h-12 bg-[#FF3B30]/10 border border-[#FF3B30]/20 flex items-center justify-center flex-shrink-0">
          <DownloadSimple weight="bold" className="w-6 h-6 text-[#FF3B30]" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-bold tracking-tight font-['Barlow_Condensed'] uppercase">Install GRIT.FIT</h4>
          <p className="text-xs text-[#A1A1AA]">Add to home screen for the full app experience</p>
        </div>
        <button onClick={handleInstall} className="btn-primary px-4 py-2 text-xs flex-shrink-0" data-testid="install-app-button">
          Install
        </button>
        <button onClick={() => setDismissed(true)} className="p-1 text-[#71717A] hover:text-white flex-shrink-0" data-testid="dismiss-install">
          <X weight="bold" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
